import { GroupBtn } from './GroupBtn'
import { InteractiveTable } from './InteractiveTable'
import { Search } from './Search'

export const HeaderDetailsPortfolio = () => {
  return (
    <>
      <GroupBtn />
      <Search />
      <InteractiveTable />
    </>
  )
}
